import { IItemWithString } from 'lib/type/common';

/** Domains from Sitecore for contact-info email autocomplete (non-empty `name`). */
export function emailDomainsForContactInfoAutocomplete(
  emailDomains: IItemWithString[] | undefined
): IItemWithString[] {
  return (emailDomains ?? []).filter(
    (item) => typeof item?.fields?.name?.value === 'string' && item.fields.name.value.trim() !== ''
  );
}
